'use client';

import { type components } from '~/fecom-api/schema';
import { Button } from '../ui/button';
import { AddToBasketButton } from './add-to-basket-button';
import { PlpQuantityInput } from '../basket/plp-quantity-input';
import { useQuantity } from '~/hooks/product/use-quantity';
import { gtmAddProductsToCart } from '~/utils/gtm/gtm-helpers';

type ProductListAddToBasketProps = {
  product: components['schemas']['Product'];
  variant?: 'standard' | 'advanced';
  buttonVariant?: 'default' | 'outline';
};

export function ProductListAddToBasket({
  product,
  variant = 'standard',
  buttonVariant,
}: ProductListAddToBasketProps) {
  const { minQuantity } = useQuantity({
    catalogueRef: product.catalogueRef,
    minimumOrderQuantity: product.minOrderQuantity,
  });

  function getButton() {
    if (product.isRestricted || product.isTemporarilyUnavailable) {
      return (
        <Button className="w-full" disabled>
          {product.isRestricted ? 'Restricted Product' : 'Back Soon'}
        </Button>
      );
    }

    if (variant === 'standard') {
      return (
        <div>
          {product.minOrderQuantity > 1 && (
            <p className="mb-1 text-center text-sm text-muted-foreground">
              {product.minOrderQuantity} minimum quantity
            </p>
          )}
          <AddToBasketButton
            className="w-full"
            itemCode={product.catalogueRef}
            productName={product.productName}
            showInBasket
            quantity={minQuantity}
            buttonVariant={buttonVariant}
            onSuccess={() => {
              gtmAddProductsToCart({
                products: [[product, minQuantity]],
                currency: 'GBP',
                itemListId: 'plp',
                itemListName: 'Product List',
              });
            }}
          />
        </div>
      );
    }

    // advanced variant
    return (
      <div>
        {product.minOrderQuantity > 1 && (
          <p className="mb-1 text-center text-sm text-muted-foreground">
            {product.minOrderQuantity} minimum quantity
          </p>
        )}
        <PlpQuantityInput
          itemCode={product.itemCode}
          minQuantity={product.minOrderQuantity}
        >
          <AddToBasketButton
            showInBasket
            className="w-full"
            itemCode={product.itemCode}
            productName={product.productName}
            quantity={product.minOrderQuantity} // moq
            onSuccess={() => {
              gtmAddProductsToCart({
                products: [[product, minQuantity]],
                currency: 'GBP',
                itemListId: 'plp',
                itemListName: 'Product List',
              });
            }}
          />
        </PlpQuantityInput>
      </div>
    );
  }

  return <div>{getButton()}</div>;
}
